module.exports = __webpack_public_path__ + "static/media/importICloud4.25b38fe0.png";